module.exports = __webpack_public_path__ + "img/06.95b11eaf.png";